/**
 * Shared, client-safe helpers for the deal document-url seam (finding H3).
 *
 * Pure strings only — safe to import from `"use client"` components AND from the
 * server-side `DealDocumentDownloadService`, so the `ref` vocabulary has a single
 * source of truth and consumers cannot typo a ref.
 */

export type DealDocumentRef =
  | "offering-okokonto"
  | "verification-okokonto"
  | "identity-buyer"
  | "identity-seller"
  | "contract"
  | "signed-contract"
  | `deal-doc:${number}`;

/** Build the `deal-doc:<index>` ref for a jsonb document at the given position
 *  within `getVisibleDocuments(deal, role)`. */
export function dealDocRef(index: number): DealDocumentRef {
  return `deal-doc:${index}`;
}

/**
 * Build the authorized `document-url` endpoint a consumer links to. The route
 * 302-redirects to a short-lived signed URL. Pass `download` to force an
 * attachment download instead of opening in the browser.
 */
export function dealDocumentUrl(
  dealId: string,
  ref: DealDocumentRef,
  opts?: { download?: boolean }
): string {
  const base = `/api/deals/${dealId}/document-url?ref=${encodeURIComponent(ref)}`;
  return opts?.download ? `${base}&download=1` : base;
}
